import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'libs/web-client/utils/auth0/src/redux/store'
import { Auth0ContextInterface } from '@auth0/auth0-react'

type Auth0Callbacks = Partial<Pick<Auth0ContextInterface, 'getAccessTokenSilently'>> & {
    isAuthenticated: () => boolean
    logout: () => void
}

type WindowReference = {
    openTime: Date
}

let referencedWindow: Window | undefined = undefined

const initialCallbacks: Auth0Callbacks = {
    getAccessTokenSilently: undefined,
    isAuthenticated: () => false,
    logout: () => null,
}

interface Auth0State {
    auth0Callbacks: Auth0Callbacks
    loginPopup: WindowReference | null
}

export const initialState: Auth0State = {
    auth0Callbacks: initialCallbacks,
    loginPopup: null,
}

const auth0Slice = createSlice({
    name: 'auth0',
    initialState,
    reducers: {
        callbacksReceived: (state, { payload: callbacks }: PayloadAction<Auth0Callbacks>) => {
            state.auth0Callbacks = callbacks
        },
        setLoginPopup: (state, { payload: { popup } }: PayloadAction<{ popup: Window }>) => {
            referencedWindow = popup
            state.loginPopup = {
                openTime: new Date(),
            }
        },
        resetLoginPopup: state => {
            referencedWindow = undefined
            state.loginPopup = null
        },
    },
})

const { actions, reducer } = auth0Slice

export const { callbacksReceived, setLoginPopup, resetLoginPopup } = actions

export default reducer

export const getAuth0State = (store: RootState): Auth0State => store.auth0
export const getCallbacks = createSelector(getAuth0State, state => state.auth0Callbacks)
export const getLoginPopup = createSelector(getAuth0State, (state): WindowReference | null =>
    state.loginPopup && referencedWindow ? state.loginPopup : null,
)
export const getLoginPopupWindow = createSelector(getLoginPopup, popup => (popup ? referencedWindow : null))
